// Google Maps API Configuration
export const GOOGLE_MAPS_CONFIG = {
  // Get API key from environment variable or use a placeholder
  apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || "YOUR_API_KEY_HERE",

  // Libraries to load
  libraries: ["places"],

  // Default map options
  mapOptions: {
    zoom: 15,
    center: { lat: 51.5074, lng: -0.1278 }, // London coordinates
  },

  // Autocomplete options
  autocompleteOptions: {
    strictBounds: false,
    types: ["geocode", "establishment"],
  },
};

// Check if Google Maps API key is configured
export const isGoogleMapsConfigured = () => {
  const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
  return apiKey && apiKey !== "YOUR_API_KEY_HERE" && apiKey.trim() !== "";
};

// Get Google Maps API key with validation
export const getGoogleMapsApiKey = () => {
  const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

  if (!apiKey || apiKey === "YOUR_API_KEY_HERE" || apiKey.trim() === "") {
    console.warn(
      "Google Maps API key is not configured. Please set VITE_GOOGLE_MAPS_API_KEY in your environment variables."
    );
    return null;
  }

  return apiKey;
};
